import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation DeleteEducationalGroup($id: Int!) {
    deleteEducationalGroup(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deleteEducationalGroup: {
    id?: number;
  };
}
